import React, { type MouseEvent } from 'react';
import noop from 'lodash/noop';
import { expVal } from '@atlassian/jira-feature-experiments';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import { AnalyticsEventToProps } from '@atlassian/jira-product-analytics-bridge';
import { VISIBLE } from '../../common/constants.tsx';
import type { TriggerAppearance } from '../../common/types.tsx';
import HiddenTrigger from './hidden/main.tsx';
import messages from './messages.tsx';
import VisibleTrigger from './visible/main.tsx';

function Trigger({
	isDisabled,
	triggerAppearance,
	isSticky,
	label,
	ariaLabel,
	ariaLabelledBy,
	onClick,
	intl: { formatMessage },
	isModalTrigger,
	shouldFocusTrigger = false,
}: {
	isDisabled?: boolean;
	isSticky: boolean;
	triggerAppearance: TriggerAppearance;
	label: string;
	ariaLabel?: string;
	ariaLabelledBy?: string;
	onClick: (arg1: MouseEvent<HTMLElement>) => void;
	intl: IntlShape;
	isModalTrigger?: boolean;
	shouldFocusTrigger?: boolean;
}) {
	const defaultLabel =
		label ||
		formatMessage(
			expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
				? messages.labelIssueTermRefresh
				: messages.label,
		);

	if (triggerAppearance === VISIBLE) {
		return (
			<VisibleTrigger
				isModalTrigger={isModalTrigger}
				isSticky={isSticky}
				label={defaultLabel}
				ariaLabel={ariaLabel}
				ariaLabelledBy={ariaLabelledBy}
				onClick={onClick}
				isDisabled={isDisabled}
				shouldFocusTrigger={shouldFocusTrigger}
			/>
		);
	}

	if (isDisabled !== true) {
		return (
			<HiddenTrigger
				label={defaultLabel}
				onClick={onClick}
				shouldFocusTrigger={shouldFocusTrigger}
			/>
		);
	}
	return null;
}

Trigger.defaultProps = {
	isDisabled: false,
	isSticky: false,
	triggerAppearance: VISIBLE,
	label: '',
	onClick: noop,
	shouldFocusTrigger: false,
};

export { Trigger };

export default AnalyticsEventToProps('button', {
	onClick: 'clicked',
})(injectIntl(Trigger));
